<script>
import store from '@state/store'
import {
  adminSettingComputed,
  adminSettingMethods,
} from '@state/helpers/admin-setting'
import {
  agentDetailsComputed,
  agentDetailsMethods,
} from '@state/helpers/agent-details'
import {
  measureListComputed,
  measureListMethods,
} from '@state/helpers/measure-list'
import {
  adminListAgentadminEditComputed,
  adminListAgentadminEditMethods,
} from '@state/helpers/admin-list-agentadmin-edit'
import {
  adminRegistrationComputed,
  adminRegistrationMethods,
} from '@state/helpers/admin-registration'
import formatDate from '@utils/format-date'
import { DATE_TIME_FORMAT } from '@utils/constant'
import { csvExport } from '@utils/helpers'
import { CSV_FILE_NAME } from '@utils/csvFilename'
import { endOfDay, startOfDay } from 'date-fns'
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: 'The Setting page.' }],
  },
  data() {
    return {
      showCreatePopup: false,
      currentUser: store.getters['auth/getCurrentUser'],
      adminAccountDataCreate: {
        level: 2,
        admin_name: '',
        admin_display_name: '',
        password: '',
        password_confirmation: '',
      },
      adminAccountEdit: {
        id: '',
        admin_id: '',
        password: '',
        password_confirmation: '',
      },
      adminLevelOptions: [
        this.getLevelType(2),
        this.getLevelType(3),
        this.getLevelType(4),
      ],
      statusEdit: {
        index: '',
        status_name: '',
        status_note: null,
      },
      dataDownload: {
        object: 'member',
        date_start: '',
        date_end: '',
      },
      dataObjectOptions: [
        {
          label: 'ユーザ情報（アライアンス登録日時）',
          value: 'member',
        },
        {
          label: '計測情報（計測日時）',
          value: 'measure',
        },
      ],
      csvKey: 0,
    }
  },
  computed: {
    ...adminSettingComputed,
    ...agentDetailsComputed,
    ...measureListComputed,
    ...adminListAgentadminEditComputed,
    ...adminRegistrationComputed,
    accountAdminList() {
      const accountList = this.getAccountList
      return accountList ? accountList.list : []
    },
    agentDetailsData() {
      return this.getDetails || {}
    },
  },
  created() {
    const agentId = this.currentUser.agent.id
    this.fetchingAccountListData()
    this.getDetailsById({ id: agentId })
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: { agent_code: user?.agent?.agent_code },
      }) // eslint-disable-next-line handle-callback-err
      .catch((error) => {})
  },
  methods: {
    ...adminSettingMethods,
    ...agentDetailsMethods,
    ...measureListMethods,
    ...adminListAgentadminEditMethods,
    ...adminRegistrationMethods,
    renderDate: function(dateTime) {
      const date = dateTime.split(' ')[0] || ''
      const time = dateTime.split(' ')[1] || ''
      return (
        '<div class="d-flex flex-wrap align-items-center">' +
        '  <p class="mb-0 mr-2">' +
        date +
        '</p>' +
        '  <p class="mb-0">' +
        time +
        '</p>' +
        '</div>'
      )
    },
    fetchingAccountListData() {
      const agentId = this.currentUser.agent.id
      this.fetchingAccountList({
        agent_id: agentId,
        page_no: 1,
        order_by: 'level',
        lines: -1,
      })
    },
    async handleAddNewAdmin() {
      const response = await this.registrationAdmin(this.adminAccountDataCreate)
      if (response) {
        await this.fetchingAccountListData()
        this.showCreatePopup = false
        this.adminAccountDataCreate = {
          level: 2,
          admin_name: '',
          admin_display_name: '',
          password: '',
          password_confirmation: '',
        }
      }
    },
    async handleDelete(manager) {
      const response = await this.deleteAccountById({ id: manager.admin_id })
      if (response) {
        await this.fetchingAccountListData()
      }
    },
    prepareHandleUpdate(manager) {
      this.adminAccountEdit = {
        id: manager ? manager.admin_id : '',
        admin_id: manager ? manager.admin_id : '',
        admin_name: manager ? manager.admin_name : '',
        admin_display_name: manager ? manager.admin_display_name : '',
        level: manager ? manager.level : 0,
        password: '',
        password_confirmation: '',
      }
    },
    async handleUpdate(adminAccountEdit) {
      const response = await this.editAgentAdmin(adminAccountEdit)
      if (response) {
        if (
          this.adminAccountEdit.password !== '' &&
          adminAccountEdit.admin_id === this.currentUser.id
        ) {
          await this.$router.push('/panel/logout')
          return
        }

        await this.fetchingAccountListData()
        this.adminAccountEdit = {
          id: '',
          admin_id: '',
          password: '',
          password_confirmation: '',
        }
      }
    },
    prepareHandleUpdateStatus(index) {
      if (index == null) {
        this.statusEdit = {
          index: '',
          status_name: '',
          status_note: '',
        }
      } else {
        const statusName =
          this.agentDetailsData['status' + index + '_name'] || ''
        const statusNote =
          this.agentDetailsData['status' + index + '_note'] || ''
        this.statusEdit = {
          index: index,
          status_name: statusName,
          status_note: statusNote,
        }
      }
    },
    async handleUpdateStatus(statusEdit) {
      const index = statusEdit.index
      const payload = {}
      payload['status' + index + '_name'] = statusEdit.status_name || ''
      payload['status' + index + '_note'] = statusEdit.status_note || ''
      const response = await this.updateAgent({
        ...this.getDetails,
        ...payload,
      })
      if (response) {
        const id = this.currentUser.agent.id
        await this.getDetailsById({ id })
        this.statusEdit = {
          index: '',
          status_name: '',
          status_note: '',
        }
      }
    },
    getLevelType(type) {
      switch (type) {
        case 1:
          return {
            label: '管理者',
            class: 'border-top-red',
            value: 1,
          }
        case 2:
          return {
            label: 'サブ管理者',
            class: 'border-top-green',
            value: 2,
          }
        case 3:
          return {
            label: '閲覧者',
            class: 'border-top-yellow',
            value: 3,
          }
        case 4:
          return {
            label: '広告配信者',
            class: 'border-top-blue',
            value: 4,
          }
        default:
          return {
            label: '',
            class: '',
            value: 0,
          }
      }
    },
    updateDownloadDate(val) {
      this.dataDownload.date_start = val.date_start
      this.dataDownload.date_end = val.date_end
    },
    async handleExport() {
      const date = {
        date_end: formatDate(
          endOfDay(new Date(this.dataDownload.date_end)),
          DATE_TIME_FORMAT
        ),
        date_start: formatDate(
          startOfDay(new Date(this.dataDownload.date_start)),
          DATE_TIME_FORMAT
        ),
      }
      if (this.dataDownload.object === 'member') {
        const response = await this.exportMemberSettingCsv({
          ...date,
        })
        csvExport(response, CSV_FILE_NAME.memberList)
        this.csvKey++
      } else if (this.dataDownload.object === 'measure') {
        const response = await this.exportMeasureCsv({
          ...date,
        })
        csvExport(response, CSV_FILE_NAME.measureList)
        this.csvKey++
      }
    },
    isShowEditInput(account) {
      const currentUser = this.currentUser
      const adminAccountEdit = this.adminAccountEdit
      return (
        adminAccountEdit.admin_id === account.admin_id &&
        account.admin_id !== currentUser.id &&
        currentUser.level !== 2 &&
        currentUser.level !== 3
      )
    },
  },
}
</script>

<template>
  <div id="admin-setting">
    <div>
      <!--admin-->
      <BaseCardCollapse title="マネージャ管理" form-collapsed>
        <template v-slot:header-action>
          <CDropdown
            v-if="currentUser.level !== 2 && currentUser.level !== 3"
            class="dropdown-inline"
            :caret="false"
            :show.sync="showCreatePopup"
            add-menu-classes="p-1"
            placement="bottom-end"
            add-toggler-classes="btn"
          >
            <template v-slot:toggler-content>
              <simple-line-icons icon="user-follow" no-svg />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <CForm
                v-if="showCreatePopup"
                ref="form"
                @submit.stop.prevent="handleSubmit(handleAddNewAdmin)"
              >
                <BaseSelect
                  label="マネージャタイプ*"
                  name="level"
                  :vee-name="'level'"
                  :value.sync="adminAccountDataCreate.level"
                  :rules="{ required: true }"
                  :options="adminLevelOptions"
                />
                <BaseInput
                  v-model="adminAccountDataCreate.admin_name"
                  :rules="{
                    requiredWithFormat: true,
                    minmax: { min: 6, max: 30 },
                    adminID: true,
                  }"
                  name="admin_name"
                  :vee-name="'admin_name'"
                  label="マネージャID*"
                />
                <BaseInput
                  v-model="adminAccountDataCreate.admin_display_name"
                  :rules="{ required: true, min: 1, max: 100 }"
                  name="admin_display_name"
                  :vee-name="'admin_display_name'"
                  label="マネージャ名*"
                />
                <BaseInput
                  v-model="adminAccountDataCreate.password"
                  :rules="{
                    requiredWithFormat: true,
                    password: true,
                  }"
                  name="password"
                  type="password"
                  :vee-name="'password'"
                  label="パスワード*"
                />
                <BaseInput
                  v-model="adminAccountDataCreate.password_confirmation"
                  :rules="{
                    requiredWithFormat: true,
                    password: true,
                    ...(adminAccountDataCreate.password.length > 0 && {
                      confirmed: 'password',
                    }),
                  }"
                  name="password_confirmation"
                  type="password"
                  :vee-name="'password_confirmation'"
                  label="パスワード確認*"
                />
                <div role="separator" class="dropdown-divider"></div>
                <CButton
                  type="submit"
                  class="btn-outline-dark pt-0 pb-0 mb-2 float-right"
                >
                  登録
                </CButton>
              </CForm>
            </validation-observer>
          </CDropdown>
        </template>
        <template>
          <div class="row">
            <div
              v-for="account in accountAdminList"
              :key="account.admin_id"
              class="col-3"
            >
              <BaseCardAction
                title=""
                form-collapsed
                min-height
                :has-edit="
                  account.admin_id === currentUser.id ||
                    (currentUser.level !== 2 && currentUser.level !== 3)
                "
                :action-header-list="[
                  {
                    type: 'delete',
                    iconType: 'CIcon',
                    icon: 'cil-trash',
                    confirm: true,
                    hide:
                      account.admin_id === currentUser.id ||
                      account.level === 1 ||
                      !(currentUser.level !== 2 && currentUser.level !== 3),
                    onclick: function() {
                      handleDelete(account)
                    },
                  },
                ]"
                :class-header="
                  getLevelType(account.level).class + ' bg-white p-0'
                "
                :trigger-mask="
                  adminAccountEdit.admin_id !== '' &&
                    adminAccountEdit.admin_id !== account.admin_id
                "
                :has-footer="adminAccountEdit.admin_id === account.admin_id"
                @edit="prepareHandleUpdate(account)"
                @cancel="prepareHandleUpdate(null)"
                @update="handleUpdate(adminAccountEdit)"
              >
                <template>
                  <div
                    class="form-group auth_control d-flex justify-content-end align-items-center"
                  >
                    <input
                      v-if="!isShowEditInput(account)"
                      type="text"
                      class="form-control-plaintext text-right"
                      disabled
                      :value="getLevelType(account.level).label"
                    />
                    <simple-line-icons icon="user" no-svg />
                    <BaseSelect
                      v-if="isShowEditInput(account)"
                      class="form-select-setting form-control-plaintext"
                      name="level"
                      :vee-name="'level'"
                      :value.sync="adminAccountEdit.level"
                      :rules="{ required: true }"
                      :options="adminLevelOptions"
                    />
                  </div>
                  <div class="form-group auth_control">
                    <BaseInput
                      v-if="isShowEditInput(account)"
                      v-model="adminAccountEdit.admin_display_name"
                      class="form-admin-display-name form-control-plaintext"
                      :rules="{ required: true, min: 1, max: 100 }"
                      name="admin_display_name"
                      :vee-name="'admin_display_name'"
                    />
                    <h5
                      v-if="!isShowEditInput(account)"
                      class="form-control-plaintext font-weight-bold admin_display_name"
                    >
                      {{ account.admin_display_name }}
                    </h5>
                  </div>
                  <div
                    class="form-group auth_control d-flex justify-content-start align-items-center"
                  >
                    <span><small>ID: </small></span>
                    <small
                      v-if="!isShowEditInput(account)"
                      class="form-control-plaintext admin_name"
                    >
                      {{ account.admin_name }}
                    </small>
                    <BaseInput
                      v-if="isShowEditInput(account)"
                      v-model="adminAccountEdit.admin_name"
                      class="form-admin-name admin_name form-control-plaintext"
                      :rules="{
                        requiredWithFormat: true,
                        minmax: { min: 6, max: 30 },
                        adminID: true,
                      }"
                      name="admin_name"
                      :vee-name="'admin_name'"
                    />
                  </div>
                  <template
                    v-if="adminAccountEdit.admin_id === account.admin_id"
                  >
                    <BaseInput
                      v-model="adminAccountEdit.password"
                      :rules="{
                        password: true,
                        requiredIf: {
                          target: adminAccountEdit.password_confirmation,
                        },
                      }"
                      name="password"
                      type="password"
                      placeholder="パスワード"
                      :vee-name="'password'"
                    />
                    <BaseInput
                      v-model="adminAccountEdit.password_confirmation"
                      :rules="{
                        password: true,
                        requiredIf: {
                          target: adminAccountEdit.password,
                        },
                        ...(adminAccountEdit.password.length > 0 && {
                          confirmed: 'password',
                        }),
                      }"
                      name="password_confirmation"
                      type="password"
                      :vee-name="'password_confirmation'"
                      placeholder="パスワード（確認）"
                    />
                  </template>
                  <div
                    class="form-group lb_login_time d-flex flex-lg-wrap align-items-baseline"
                  >
                    <input
                      type="text"
                      class="form-control-plaintext w-input"
                      disabled
                      value="最終ログイン時間 :"
                    />
                    <!-- eslint-disable vue/no-v-html -->
                    <label v-html="renderDate(account.login_time)" />
                    <!--eslint-enable-->
                  </div>
                </template>
              </BaseCardAction>
            </div>
          </div>
        </template>
      </BaseCardCollapse>
      <BaseCardCollapse title="ステータスリスト編集" form-collapsed>
        <template>
          <div class="row">
            <div
              v-for="indexStatus in [1, 2, 3, 4, 5, 6, 7, 8]"
              :key="'indexStatus' + indexStatus"
              class="col-3"
            >
              <BaseCardAction
                title=""
                form-collapsed
                class-header=" bg-white p-0 border-bottom-0"
                :has-edit="currentUser.level !== 3"
                :trigger-mask="
                  statusEdit.index !== '' && statusEdit.index !== indexStatus
                "
                :has-footer="statusEdit.index === indexStatus"
                @edit="prepareHandleUpdateStatus(indexStatus)"
                @cancel="prepareHandleUpdateStatus(null)"
                @update="handleUpdateStatus(statusEdit)"
              >
                <template v-if="statusEdit.index === indexStatus">
                  <div class="form-group">
                    <BaseInput
                      v-model="statusEdit.status_name"
                      :rules="{ required: true, max: 100 }"
                      name="status_name"
                      :vee-name="'status_name'"
                    />
                  </div>
                  <div class="form-group ">
                    <BaseTextarea
                      v-model="statusEdit.status_note"
                      :rules="{ max: 100 }"
                      name="status_note"
                      :vee-name="'status_note'"
                    />
                  </div>
                </template>
                <template v-else>
                  <div class="form-group">
                    <BaseInput
                      v-model="
                        agentDetailsData['status' + indexStatus + '_name']
                      "
                      readonly
                    />
                  </div>
                  <div class="form-group ">
                    <BaseTextarea
                      v-model="
                        agentDetailsData['status' + indexStatus + '_note']
                      "
                      readonly
                    />
                  </div>
                </template>
              </BaseCardAction>
            </div>
          </div>
        </template>
      </BaseCardCollapse>
    </div>
    <div class="row">
      <div class="col-md-4">
        <BaseCardAction
          title="データダウンロード"
          form-collapsed
          ignore-confirm
          @update="handleExport"
        >
          <template>
            <div class="form-group">
              <BaseSelect
                label="対象"
                name="object"
                :vee-name="'level'"
                :value.sync="dataDownload.object"
                :rules="{ required: true }"
                :options="dataObjectOptions"
              />
            </div>
            <div class="form-group">
              <label class="col-form-label"
                >期間<span class="text-danger">*</span></label
              >
              <BaseDateRangerPickerCsv
                :key="csvKey"
                :rules="{ required: true }"
                :start-date="dataDownload.date_start"
                :end-date="dataDownload.date_end"
                picker-type="date"
                @update:value="(v) => updateDownloadDate(v)"
              />
            </div>
            <div class="text-center mt-2">
              <CButton type="submit" class="btn-outline-dark">
                ダウンロード
              </CButton>
            </div>
          </template>
        </BaseCardAction>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropdown-inline {
  display: inline-block;
}
</style>

<style lang="scss">
#admin-setting {
  .card-header {
    h3 {
      color: #73818f;
    }
  }

  .form-admin-display-name {
    .form-group {
      margin-bottom: 0;
      .form-control {
        font-weight: 700 !important;
      }
    }
  }

  .form-admin-name {
    .form-group {
      margin-bottom: 0;
    }
  }

  .form-select-setting {
    .form-group {
      margin-bottom: 0;
    }
  }
}
</style>
